import React, { useState, useEffect } from 'react';
import {Link,useLocation} from 'react-router-dom';
import { motion } from 'framer-motion';
import { useApp } from '../contexts/AppContext';
import { settingsService } from '../services/settingsService';
import { dbService } from '../services/dbService';
import { sampleDataService } from '../services/sampleDataService';
import ConfirmDialog from '../components/ConfirmDialog';


import GoogleSyncPanel from '../components/GoogleSyncPanel';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import * as Fi from 'react-icons/fi';
import {validCategoryRule} from '../services/categorizationRules';


// Kept as a private LoadingSpinner module to preserve the original component behavior.
const LoadingSpinner = (()=>{


const LoadingSpinner = ({ message = 'Loading...', size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <motion.div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="bg-white rounded-lg shadow-xl p-6 flex flex-col items-center space-y-4"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
      >
        <div className={`border-4 border-primary-200 border-t-primary-500 rounded-full animate-spin ${sizeClasses[size]}`} />
        <p className="text-gray-700 font-medium">{message}</p>
      </motion.div>
    </motion.div>
  );
};



return LoadingSpinner;
})();

// Kept as a private CategorizationRulesPanel module to preserve the original component behavior.
const CategorizationRulesPanel = (()=>{



const empty={pattern:'',type:'expense',match:'contains',category:'',priority:0,enabled:true};
function CategorizationRulesPanel({rules=[],categories=[],onChange}){
 const [form,setForm]=useState(empty),[editing,setEditing]=useState(null),[error,setError]=useState(''),[busy,setBusy]=useState(false);
 const update=(name,value)=>setForm(f=>({...f,[name]:value,...(name==='type'?{category:''}:{})}));
 const save=async e=>{e.preventDefault();if(busy)return;setError('');setBusy(true);
  try {const candidate=validCategoryRule({...form,id:editing??String(Date.now())+'-'+Math.random().toString(36).slice(2)},categories,rules);
   await onChange(editing?rules.map(r=>r.id===editing?candidate:r):[...rules,candidate]);setForm(empty);setEditing(null);
  }catch(err){setError(err.message)}finally{setBusy(false)}
 };
 const del=async id=>{setError('');try{await onChange(rules.filter(r=>r.id!==id));if(editing===id){setEditing(null);setForm(empty)}}catch(err){setError(err.message)}};
 return <section className="space-y-4" aria-label="Automatic categorisation rules">
 <div className="flex items-start gap-3"><div className="p-3 bg-blue-50 rounded-xl text-blue-600"><Fi.FiZap/></div><div><h2 className="text-lg font-bold text-slate-900">Automatic categorisation</h2><p className="text-sm text-slate-500">Match a merchant name to an existing category. Manual choices always win. Rules are stored locally until you explicitly sync.</p></div></div>
 <form onSubmit={save} className="grid sm:grid-cols-2 gap-3 border border-slate-200 bg-slate-50 p-4 rounded-xl">
 <label className="text-sm font-semibold text-slate-600">Merchant contains<input required value={form.pattern} onChange={e=>update('pattern',e.target.value)} placeholder="e.g. woolworths" className="block w-full rounded-xl border border-slate-200 px-3 py-3 mt-1"/></label>
 <label className="text-sm font-semibold text-slate-600">Transaction type<select value={form.type} onChange={e=>update('type',e.target.value)} className="block w-full rounded-xl border border-slate-200 px-3 py-3 mt-1"><option value="expense">Expense</option><option value="income">Income</option></select></label>
 <label className="text-sm font-semibold text-slate-600">Match method<select value={form.match} onChange={e=>update('match',e.target.value)} className="block w-full rounded-xl border border-slate-200 px-3 py-3 mt-1"><option value="contains">Contains</option><option value="startsWith">Starts with</option><option value="exact">Exactly matches</option></select></label>
 <label className="text-sm font-semibold text-slate-600">Assign category<select required value={form.category} onChange={e=>update('category',e.target.value)} className="block w-full rounded-xl border border-slate-200 px-3 py-3 mt-1"><option value="">Select category</option>{categories.filter(c=>c.type===form.type).map(c=><option key={c.id} value={c.name}>{c.name}</option>)}</select></label>
 {error&&<p role="alert" className="sm:col-span-2 text-rose-600 text-sm">{error}</p>}
 <div className="sm:col-span-2 flex gap-2 flex-wrap"><button disabled={busy} className="bg-blue-600 text-white rounded-xl px-4 py-3 font-semibold text-sm">{editing?'Save Rule':'Add Rule'}</button>{editing&&<button type="button" onClick={()=>{setEditing(null);setForm(empty)}} className="border rounded-xl px-4 py-3">Cancel</button>}</div></form>
 <div className="space-y-2">{rules.map(r=><div key={r.id} className="flex items-center gap-2 sm:gap-3 border border-slate-200 rounded-xl p-3">
  <div className="min-w-0 flex-1"><div className="font-semibold text-sm text-slate-900 truncate">{r.pattern} → {r.category}</div><p className="text-xs text-slate-500">{r.type} · {r.match}</p></div>
  <button type="button" aria-label={'Edit '+r.pattern} onClick={()=>{setEditing(r.id);setForm({...r});setError('')}} className="h-11 w-11 shrink-0 grid place-items-center rounded-xl text-blue-600 bg-blue-50"><Fi.FiEdit2/></button>
  <button type="button" aria-label={'Delete '+r.pattern} onClick={()=>del(r.id)} className="h-11 w-11 shrink-0 grid place-items-center rounded-xl text-rose-600 bg-rose-50"><Fi.FiTrash2/></button>
 </div>)}{!rules.length&&<p className="text-sm text-slate-500">No rules yet. Add your first merchant above.</p>}</div></section>
}

return CategorizationRulesPanel;
})();

const {
  FiSettings,
  FiDollarSign,
  FiCalendar,
  FiHardDrive,
  FiDownload,
  FiUpload,
  FiTrash2,
  FiDatabase,
  FiFolder,
  FiCheck,
  FiX,
  FiAlertTriangle,
} = FiIcons;

const Settings = () => {
  const { state, dispatch, actions } = useApp();
  const { settings } = state;
  const location=useLocation();
  // The Transactions Import shortcut opens the existing full-backup page.
  // No importer, database operation or Google schema is changed here.
  // An overview of cards is the default; existing deep links (e.g. Transactions > Import)
  // still open the relevant settings panel directly.
  const [activeTab, setActiveTab] = useState(['backup','google'].includes(location.state?.openTab)?location.state.openTab:null);
  useEffect(()=>{if(['backup','google'].includes(location.state?.openTab))setActiveTab(location.state.openTab);},[location.state?.openTab]);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(null);
  const [sampleDataCounts, setSampleDataCounts] = useState({
    transactions: 0,
    categories: 0,
    budgets: 0,
    people: 0,
    recurringRules: 0,
    ious: 0,
  });

  // Load sample data counts when tab changes to data
  useEffect(() => {
    if (activeTab === 'data') {
      loadSampleDataCounts();
    }
  }, [activeTab]);

  const loadSampleDataCounts = async () => {
    try {
      const counts = await sampleDataService.getSampleDataCounts();
      setSampleDataCounts(counts);
    } catch (error) {
      console.error('Failed to load sample data counts:', error);
    }
  };

  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const handleSettingChange = async (key, value) => {
    setIsSaving(true);
    try {
      await settingsService.setSetting(key, value);
      dispatch({ type: 'SET_SETTINGS', payload: { [key]: value } });
      showNotification('Setting updated successfully');
    } catch (error) {
      console.error('Failed to update setting:', error);
      showNotification('Failed to update setting', 'error');
    } finally {
      setIsSaving(false);
    }
  };

  const handleLoadSampleData = () => {
    setConfirmDialog({
      title: 'Load Sample Data',
      message: 'This will add realistic sample data to help you explore the app features. The sample data includes transactions, budgets, people, and recurring rules covering 4 years of data.',
      confirmText: 'Load Sample Data',
      confirmStyle: 'primary',
      onConfirm: async () => {
        setIsLoading(true);
        try {
          const result = await sampleDataService.loadSampleData(4, true);
          
          if (result.success) {
            showNotification(
              `Sample data loaded successfully! Added ${result.counts.transactions} transactions, ${result.counts.categories} categories, ${result.counts.budgets} budgets, ${result.counts.people} people, and ${result.counts.recurringRules} recurring rules.`
            );
            
            // Refresh the app data
            await actions.loadData();
            await loadSampleDataCounts();
          } else {
            showNotification(`Failed to load sample data: ${result.error}`, 'error');
          }
        } catch (error) {
          console.error('Failed to load sample data:', error);
          showNotification('Failed to load sample data', 'error');
        } finally {
          setIsLoading(false);
          setConfirmDialog(null);
        }
      },
      onCancel: () => setConfirmDialog(null),
    });
  };

  const handleDeleteSampleData = () => {
    const totalSampleItems = Object.values(sampleDataCounts).reduce((sum, count) => sum + count, 0);
    
    if (totalSampleItems === 0) {
      showNotification('No sample data found to delete', 'error');
      return;
    }

    setConfirmDialog({
      title: 'Delete Sample Data',
      message: `This will permanently delete all sample data from your app. This includes ${sampleDataCounts.transactions} transactions, ${sampleDataCounts.categories} categories, ${sampleDataCounts.budgets} budgets, ${sampleDataCounts.people} people, and ${sampleDataCounts.recurringRules} recurring rules. This action cannot be undone.`,
      confirmText: 'Delete Sample Data',
      confirmStyle: 'danger',
      onConfirm: async () => {
        setIsLoading(true);
        try {
          const result = await sampleDataService.deleteSampleData();
          
          if (result.success) {
            showNotification(
              `Sample data deleted successfully! Removed ${result.deletedCounts.transactions} transactions, ${result.deletedCounts.categories} categories, ${result.deletedCounts.budgets} budgets, ${result.deletedCounts.people} people, and ${result.deletedCounts.recurringRules} recurring rules.`
            );
            
            // Refresh the app data
            await actions.loadData();
            await loadSampleDataCounts();
          } else {
            showNotification(`Failed to delete sample data: ${result.error}`, 'error');
          }
        } catch (error) {
          console.error('Failed to delete sample data:', error);
          showNotification('Failed to delete sample data', 'error');
        } finally {
          setIsLoading(false);
          setConfirmDialog(null);
        }
      },
      onCancel: () => setConfirmDialog(null),
    });
  };

  const handleResetAllData = () => {
    setConfirmDialog({
      title: 'Reset All Data',
      message: 'This will permanently delete ALL your data and reset the app to its initial state. This includes all transactions, budgets, people, recurring rules, and custom categories. Only the default categories will remain. This action cannot be undone.',
      confirmText: 'Reset Everything',
      confirmStyle: 'danger',
      requiresConfirmation: true,
      confirmationText: 'DELETE ALL DATA',
      onConfirm: async () => {
        setIsLoading(true);
        try {
          const result = await sampleDataService.resetAllData();
          
          if (result.success) {
            showNotification('All data has been reset successfully');
            
            // Refresh the app data
            await actions.loadData();
            await loadSampleDataCounts();
          } else {
            showNotification(`Failed to reset data: ${result.error}`, 'error');
          }
        } catch (error) {
          console.error('Failed to reset data:', error);
          showNotification('Failed to reset data', 'error');
        } finally {
          setIsLoading(false);
          setConfirmDialog(null);
        }
      },
      onCancel: () => setConfirmDialog(null),
    });
  };

  const handleBackup = async () => {
    try {
      const data = await dbService.exportData();
      const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: 'application/json',
      });

      const filename = `expense-manager-backup-${new Date().toISOString().split('T')[0]}.json`;
      
      // Check if File System Access API is available
      if ('showSaveFilePicker' in window) {
        try {
          const fileHandle = await window.showSaveFilePicker({
            suggestedName: filename,
            types: [{
              description: 'JSON files',
              accept: { 'application/json': ['.json'] },
            }],
          });
          
          const writable = await fileHandle.createWritable();
          await writable.write(blob);
          await writable.close();
          
          await settingsService.setSetting('lastBackup', new Date().toISOString());
          showNotification('Backup saved successfully');
        } catch (err) {
          if (err.name !== 'AbortError') {
            throw err;
          }
        }
      } else {
        // Fallback for other browsers
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        
        await settingsService.setSetting('lastBackup', new Date().toISOString());
        showNotification('Backup downloaded successfully');
      }
    } catch (error) {
      console.error('Backup failed:', error);
      showNotification('Backup failed', 'error');
    }
  };

  const handleImport = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const text = await file.text();
      const data = JSON.parse(text);
      
      if (!data.data || !data.version) {
        throw new Error('Invalid backup file format');
      }

      await dbService.importData(data);
      showNotification('Data imported successfully');
      
      // Reload the page to refresh all data
      window.location.reload();
    } catch (error) {
      console.error('Import failed:', error);
      showNotification('Import failed: ' + error.message, 'error');
    }
    
    // Reset file input
    event.target.value = '';
  };

  const animationProps = settings.reducedMotion
    ? {}
    : {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.3 },
      };

  const googleEnabled=import.meta.env.VITE_BPA_ENABLE_GOOGLE_SYNC==='true';
  const tabs=[
    {
      id:'general',name:'General',icon:FiSettings,
      description:'Currency, financial year, date format and backup preferences.',
      status:(settings.currency||'AUD')+' · '+(settings.dateFormat==='system'?'System date format':settings.dateFormat||'System date format'),
      tint:'bg-sky-50 text-[#0176D3]'
    },
    {
      id:'backup',name:'Backup & Import',icon:FiHardDrive,
      description:'Download a local backup or safely restore data from a file.',
      status:settings.lastBackup?'Last local backup: '+new Date(settings.lastBackup).toLocaleDateString('en-AU'):'Manual backup available',
      tint:'bg-emerald-50 text-emerald-700'
    },
    {
      id:'data',name:'Data Management',icon:FiDatabase,
      description:'View workspace storage, sample records and reset safeguards.',
      status:(state.transactions?.length||0)+' transactions · '+(state.people?.length||0)+' people',
      tint:'bg-violet-50 text-violet-700'
    },
    {
      id:'automation',name:'Automation',icon:FiIcons.FiZap,
      description:'Manage merchant categorisation rules and budget alerts.',
      status:(settings.categorizationRules?.length||0)+' rules · Warning at '+(settings.budgetWarningPercent??80)+'%',
      tint:'bg-orange-50 text-orange-700'
    },
    ...(googleEnabled?[{
      id:'google',name:'Google Sheets Sync',icon:FiIcons.FiCloud,
      description:'Manage your Google connection, spreadsheet and backups.',
      status:'Google connection and recovery',
      tint:'bg-blue-50 text-blue-700'
    }]:[])
  ];
  const activeConfig=tabs.find(tab=>tab.id===activeTab);

  return (
    <motion.div className="settings-page min-w-0 space-y-5 pb-10 md:space-y-6" {...animationProps}>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-3xl font-extrabold tracking-tight text-slate-950">Settings</h1>
          <p className="mt-1 text-sm text-slate-600">Configure your preferences and manage your data</p>
        </div>
        {activeConfig&&<button type="button" onClick={()=>setActiveTab(null)}
          className="inline-flex min-h-10 items-center self-start gap-2 rounded-xl border border-blue-200 bg-white px-4 py-2 text-xs font-bold text-[#0176D3] hover:bg-blue-50 focus-visible:ring-2 focus-visible:ring-blue-300">
          <Fi.FiArrowLeft size={16}/> All Settings
        </button>}
      </div>

      {/* Preserve the original user feedback and in-progress overlays. */}
      {notification&&(
        <motion.div role="status" aria-live="polite"
          className={'flex items-center gap-2 rounded-xl border p-3 text-sm font-semibold '+(
            notification.type==='error'
             ?'border-rose-200 bg-rose-50 text-rose-700'
             :'border-emerald-200 bg-emerald-50 text-emerald-700')}
          initial={{opacity:0,y:-8}} animate={{opacity:1,y:0}}>
          <SafeIcon icon={notification.type==='error'?FiX:FiCheck} className="h-5 w-5 shrink-0"/>
          {notification.message}
        </motion.div>
      )}
      {isLoading&&<LoadingSpinner message="Processing data..."/>}

      {activeTab===null?(
        <>
          <section className="rounded-2xl border border-blue-100 bg-gradient-to-r from-white via-[#f1f8ff] to-[#e7f3ff] px-4 py-4 sm:px-6 sm:py-5">
            <div className="flex items-center gap-3">
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-white text-[#0176D3] shadow-sm">
                <Fi.FiSliders size={24}/>
              </span>
              <div className="min-w-0">
                <h2 className="text-base font-extrabold text-slate-950 sm:text-lg">Your workspace, your preferences</h2>
                <p className="mt-1 text-xs leading-relaxed text-[#48607e] sm:text-sm">
                  Choose a settings card to manage your current preferences, automation and backups.
                </p>
              </div>
            </div>
          </section>
          <Link to="/help" className="flex min-w-0 items-center gap-3 rounded-2xl border border-[#dce5f0] bg-white px-4 py-4 text-[#032D60] shadow-sm hover:border-[#9ad0f8] hover:bg-blue-50 focus-visible:ring-2 focus-visible:ring-[#0176D3] sm:px-5">
            <Fi.FiBookOpen className="shrink-0 text-[#0176D3]" size={22}/>
            <span className="min-w-0 flex-1"><strong className="block text-sm">Help &amp; Setup</strong><span className="block text-xs text-slate-600">First-time Google approval, using another device and keeping records up to date.</span></span>
            <Fi.FiArrowRight className="shrink-0" size={18}/>
          </Link>
          <nav aria-label="Settings categories" className="grid min-w-0 grid-cols-1 gap-4 sm:grid-cols-2 2xl:grid-cols-3">
            {tabs.map(tab=>{
              const CardIcon=tab.icon;
              return <button type="button" key={tab.id}
                aria-label={tab.name}
                onClick={()=>setActiveTab(tab.id)}
                className="group flex min-h-[178px] min-w-0 flex-col rounded-2xl border border-[#dce5f0] bg-white p-5 text-left shadow-[0_4px_16px_rgba(15,43,82,.045)] transition duration-150 hover:-translate-y-0.5 hover:border-[#9ad0f8] hover:shadow-md focus-visible:ring-2 focus-visible:ring-[#0176D3]">
                <div className="flex w-full items-start justify-between gap-3">
                  <span className={'grid h-12 w-12 shrink-0 place-items-center rounded-2xl '+tab.tint}>
                    <CardIcon size={23}/>
                  </span>
                  <Fi.FiArrowUpRight size={19} className="text-slate-400 transition group-hover:text-[#0176D3]"/>
                </div>
                <h2 className="mt-4 text-base font-extrabold text-slate-950">{tab.name}</h2>
                <p className="mt-1 min-h-8 text-xs leading-relaxed text-slate-600">{tab.description}</p>
                <div className="mt-auto flex w-full items-center gap-2 border-t border-slate-100 pt-3 text-xs font-semibold text-[#385575]">
                  <Fi.FiCheckCircle size={14} className="shrink-0 text-[#0176D3]"/>
                  <span className="min-w-0 truncate" title={tab.status}>{tab.status}</span>
                </div>
              </button>;
            })}
          </nav>
        </>
      ):(
        <section className="min-w-0 space-y-4" aria-label={activeConfig?.name+' settings'}>
          <div className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-[#dce5f0] bg-white p-4 shadow-sm sm:p-5">
            <div className="flex min-w-0 items-center gap-3">
              <span className={'grid h-12 w-12 shrink-0 place-items-center rounded-2xl '+(activeConfig?.tint||'bg-sky-50 text-[#0176D3]')}>
                {activeConfig&&<activeConfig.icon size={23}/>}
              </span>
              <div className="min-w-0">
                <p className="text-[11px] font-bold uppercase tracking-wide text-[#0176D3]">Workspace settings</p>
                <h2 className="mt-0.5 text-lg font-extrabold text-slate-950">{activeConfig?.name}</h2>
                <p className="mt-1 text-xs leading-relaxed text-slate-600">{activeConfig?.description}</p>
              </div>
            </div>
            <span className="rounded-full bg-sky-50 px-3 py-1.5 text-xs font-semibold text-sky-700">{activeConfig?.status}</span>
          </div>
          <div className="min-w-0 overflow-hidden rounded-2xl border border-[#dce5f0] bg-white shadow-[0_4px_18px_rgba(15,43,82,.045)]">
            {/* General Settings */}
            {activeTab === 'general' && (
              <motion.div className="space-y-6 p-4 sm:p-6" {...animationProps}>
                <h2 className="text-lg font-semibold text-gray-900">General Settings</h2>
                
                {/* Currency */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <SafeIcon icon={FiDollarSign} className="w-4 h-4 inline mr-2" />
                    Default Currency
                  </label>
                  <select
                    value={settings.currency}
                    onChange={(e) => handleSettingChange('currency', e.target.value)}
                    disabled={isSaving}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                  >
                    <option value="AUD">Australian Dollar (AUD)</option>
                    <option value="USD">US Dollar (USD)</option>
                    <option value="EUR">Euro (EUR)</option>
                    <option value="GBP">British Pound (GBP)</option>
                    <option value="CAD">Canadian Dollar (CAD)</option>
                    <option value="JPY">Japanese Yen (JPY)</option>
                  </select>
                </div>

                {/* Financial Year Start */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <SafeIcon icon={FiCalendar} className="w-4 h-4 inline mr-2" />
                    Financial Year Start
                  </label>
                  <select
                    value={settings.financialYearStart}
                    onChange={(e) => handleSettingChange('financialYearStart', e.target.value)}
                    disabled={isSaving}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                  >
                    <option value="01-01">January 1</option>
                    <option value="04-01">April 1</option>
                    <option value="07-01">July 1 (Australia)</option>
                    <option value="10-01">October 1</option>
                  </select>
                  <p className="text-xs text-gray-500 mt-1">
                    This affects financial year calculations in reports
                  </p>
                </div>

                {/* Date Format */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Date Format
                  </label>
                  <select
                    value={settings.dateFormat}
                    onChange={(e) => handleSettingChange('dateFormat', e.target.value)}
                    disabled={isSaving}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                  >
                    <option value="system">System Default</option>
                    <option value="dd/mm/yyyy">DD/MM/YYYY</option>
                    <option value="mm/dd/yyyy">MM/DD/YYYY</option>
                    <option value="yyyy-mm-dd">YYYY-MM-DD</option>
                  </select>
                </div>

                {/* Auto Backup */}
                <div>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.autoBackup}
                      onChange={(e) => handleSettingChange('autoBackup', e.target.checked)}
                      disabled={isSaving}
                      className="rounded border-gray-300 text-primary-600 focus:ring-primary-500"
                    />
                    <span className="ml-2 text-sm text-gray-700">
                      Enable automatic backups every 15 minutes
                    </span>
                  </label>
                </div>
              </motion.div>
            )}

            {activeTab === 'automation' && <div className="p-4 md:p-6 space-y-6">
             <CategorizationRulesPanel rules={settings.categorizationRules||[]} categories={state.categories}
               onChange={next=>handleSettingChange('categorizationRules',next)}/>
             <section className="border border-slate-200 rounded-xl p-4 space-y-3">
              <h2 className="font-bold text-slate-900">Budget alerts</h2>
              <p className="text-sm text-slate-500">Show a warning when spending crosses this percentage of a category's budget. Forecasts are estimates, not money available to spend.</p>
              <div className="flex flex-col gap-2">
                <p id="budget-threshold-label" className="text-sm font-semibold text-slate-700">Warning threshold</p>
                {/* Use accessible single-choice buttons instead of the browser-native
                    select popup that could render as a large blank overlay. */}
                <div id="budget-threshold" role="group" aria-labelledby="budget-threshold-label"
                  className="grid grid-cols-3 gap-2 sm:grid-cols-5">
                  {[60,70,80,90,100].map(value=><button
                    key={value} type="button" aria-pressed={Number(settings.budgetWarningPercent??80)===value}
                    onClick={()=>handleSettingChange('budgetWarningPercent',value)} disabled={isSaving}
                    className={'min-h-11 rounded-xl border px-2 py-2.5 text-sm font-bold tabular-nums transition focus-visible:ring-2 focus-visible:ring-blue-300 disabled:cursor-wait disabled:opacity-50 '+(
                      Number(settings.budgetWarningPercent??80)===value
                        ?'border-[#0176D3] bg-[#0176D3] text-white shadow-sm'
                        :'border-[#dce5f0] bg-white text-slate-700 hover:border-blue-300 hover:bg-blue-50'
                    )}>{value}%</button>)}
                </div>
                <p className="text-xs text-slate-500">Current warning threshold: <strong>{settings.budgetWarningPercent??80}%</strong>. This uses the existing saved setting.</p>
              </div>
             </section>
            </div>}
            {import.meta.env.VITE_BPA_ENABLE_GOOGLE_SYNC === 'true' && activeTab === 'google' && <GoogleSyncPanel/>}

            {/* Backup & Import */}
            {activeTab === 'backup' && (
              <motion.div className="space-y-6 p-4 sm:p-6" {...animationProps}>
                <h2 className="text-lg font-semibold text-gray-900">Backup & Import</h2>
                
                {/* Backup Section */}
                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-md font-medium text-gray-900 mb-3">Backup Data</h3>
                  <div className="space-y-3">
                    <div className="flex flex-wrap items-center justify-between gap-3">
                      <div className="min-w-0">
                        <p className="text-sm text-gray-700">Last backup:</p>
                        <p className="text-xs text-gray-500">
                          {settings.lastBackup 
                            ? new Date(settings.lastBackup).toLocaleString('en-AU')
                            : 'Never'
                          }
                        </p>
                      </div>
                      <button
                        onClick={handleBackup}
                        className="inline-flex min-h-11 items-center justify-center px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium transition-colors duration-200"
                      >
                        <SafeIcon icon={FiDownload} className="w-4 h-4 mr-2" />
                        Backup Now
                      </button>
                    </div>

                    {/* Folder settings for Chromium browsers */}
                    {'showDirectoryPicker' in window && (
                      <div className="pt-3 border-t border-gray-200">
                        <div className="flex flex-wrap items-center justify-between gap-3">
                          <div>
                            <p className="text-sm text-gray-700">Backup folder:</p>
                            <p className="text-xs text-gray-500">
                              {settings.backupFolder || 'Not set'}
                            </p>
                          </div>
                          <div className="flex flex-wrap gap-2">
                            <button
                              onClick={async () => {
                                try {
                                  const dirHandle = await window.showDirectoryPicker();
                                  await handleSettingChange('backupFolder', dirHandle.name);
                                } catch (err) {
                                  if (err.name !== 'AbortError') {
                                    console.error('Failed to set backup folder:', err);
                                  }
                                }
                              }}
                              className="flex items-center px-3 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded text-sm transition-colors duration-200"
                            >
                              <SafeIcon icon={FiFolder} className="w-3 h-3 mr-1" />
                              Set Folder
                            </button>
                            {settings.backupFolder && (
                              <button
                                onClick={() => handleSettingChange('backupFolder', null)}
                                className="flex items-center px-3 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded text-sm transition-colors duration-200"
                              >
                                Clear
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Import Section */}
                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-md font-medium text-gray-900 mb-3">Import Data</h3>
                  <div className="space-y-3">
                    <p className="text-sm text-gray-600">
                      Import data from a backup file. This will replace all existing data.
                    </p>
                    <div>
                      <input
                        type="file"
                        accept=".json"
                        onChange={handleImport}
                        className="hidden"
                        id="import-file"
                      />
                      <label
                        htmlFor="import-file"
                        className="inline-flex items-center px-4 py-2 bg-warning-500 hover:bg-warning-600 text-white rounded-lg font-medium cursor-pointer transition-colors duration-200"
                      >
                        <SafeIcon icon={FiUpload} className="w-4 h-4 mr-2" />
                        Import Backup
                      </label>
                    </div>
                  </div>
                </div>
              </motion.div>
            )}

            {/* Data Management */}
            {activeTab === 'data' && (
              <motion.div className="space-y-6 p-4 sm:p-6" {...animationProps}>
                <h2 className="text-lg font-semibold text-gray-900">Data Management</h2>
                
                {/* Sample Data */}
                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-md font-medium text-gray-900 mb-3">Sample Data</h3>
                  <div className="space-y-3">
                    <p className="text-sm text-gray-600">
                      Load sample data to explore the app features or delete existing sample data.
                    </p>
                    
                    {/* Current sample data info */}
                    <div className="bg-gray-50 p-3 rounded-lg text-sm">
                      <h4 className="font-medium text-gray-900 mb-2">Current Sample Data:</h4>
                      <div className="grid grid-cols-2 gap-2 text-gray-600">
                        <div>Transactions: {sampleDataCounts.transactions}</div>
                        <div>Categories: {sampleDataCounts.categories}</div>
                        <div>Budgets: {sampleDataCounts.budgets}</div>
                        <div>People: {sampleDataCounts.people}</div>
                        <div>Recurring Rules: {sampleDataCounts.recurringRules}</div>
                      </div>
                    </div>
                    
                    <div className="flex flex-wrap gap-2">
                      <button 
                        onClick={handleLoadSampleData}
                        disabled={isLoading}
                        className="flex items-center px-4 py-2 bg-primary-500 hover:bg-primary-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg font-medium transition-colors duration-200"
                      >
                        <SafeIcon icon={FiDatabase} className="w-4 h-4 mr-2" />
                        Load Sample Data
                      </button>
                      <button 
                        onClick={handleDeleteSampleData}
                        disabled={isLoading || Object.values(sampleDataCounts).reduce((sum, count) => sum + count, 0) === 0}
                        className="flex items-center px-4 py-2 bg-warning-500 hover:bg-warning-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg font-medium transition-colors duration-200"
                      >
                        <SafeIcon icon={FiTrash2} className="w-4 h-4 mr-2" />
                        Delete Sample Data
                      </button>
                    </div>
                  </div>
                </div>

                {/* Reset Data */}
                <div className="border border-danger-200 rounded-lg p-4 bg-danger-50">
                  <h3 className="text-md font-medium text-danger-900 mb-3">
                    <SafeIcon icon={FiAlertTriangle} className="w-4 h-4 inline mr-2" />
                    Danger Zone
                  </h3>
                  <div className="space-y-3">
                    <p className="text-sm text-danger-700">
                      Reset all data to start fresh. This action cannot be undone.
                    </p>
                    <button 
                      onClick={handleResetAllData}
                      disabled={isLoading}
                      className="flex items-center px-4 py-2 bg-danger-500 hover:bg-danger-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg font-medium transition-colors duration-200"
                    >
                      <SafeIcon icon={FiTrash2} className="w-4 h-4 mr-2" />
                      Reset to Empty
                    </button>
                  </div>
                </div>

                {/* Storage Info */}
                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-md font-medium text-gray-900 mb-3">Storage Information</h3>
                  <div className="space-y-2 text-sm text-gray-600">
                    <div className="flex justify-between">
                      <span>Transactions:</span>
                      <span>{state.transactions.length}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Categories:</span>
                      <span>{state.categories.length}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Budgets:</span>
                      <span>{state.budgets.length}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>People:</span>
                      <span>{state.people.length}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Recurring Rules:</span>
                      <span>{state.recurringRules.length}</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
          </div>
        </section>
      )}

      {/* Confirm Dialog */}
      {confirmDialog && (
        <ConfirmDialog
          title={confirmDialog.title}
          message={confirmDialog.message}
          confirmText={confirmDialog.confirmText}
          confirmStyle={confirmDialog.confirmStyle}
          requiresConfirmation={confirmDialog.requiresConfirmation}
          confirmationText={confirmDialog.confirmationText}
          onConfirm={confirmDialog.onConfirm}
          onCancel={confirmDialog.onCancel}
        />
      )}
    </motion.div>
  );
};


// Customer-facing setup guide. This is intentionally informational only:
// no Google API calls, account changes or financial storage operations.
function GuideStep({number,title,children}){
 return <li className="flex min-w-0 gap-3 rounded-xl border border-slate-100 bg-white p-3 sm:p-4">
  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-blue-50 text-sm font-bold text-[#0176D3]">{number}</span>
  <div className="min-w-0 space-y-1"><h3 className="text-sm font-bold text-[#032D60]">{title}</h3><div className="text-sm leading-6 text-slate-600">{children}</div></div>
 </li>;
}

export function HelpPage(){
 const googleEnabled=import.meta.env.VITE_BPA_ENABLE_GOOGLE_SYNC==='true';
 return <div className="settings-page min-w-0 space-y-5 pb-10 sm:space-y-6" aria-label="Expense Manager help and setup">
  <header className="min-w-0 overflow-hidden rounded-2xl border border-blue-100 bg-gradient-to-r from-white to-[#edf6ff] p-5 sm:p-7">
   <div className="flex items-start gap-3">
    <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-white text-[#0176D3] shadow-sm"><Fi.FiBookOpen size={25}/></span>
    <div className="min-w-0"><p className="text-xs font-bold uppercase tracking-widest text-[#0176D3]">Getting started</p>
     <h1 className="mt-1 text-2xl font-extrabold tracking-tight text-[#032D60] sm:text-3xl">Help &amp; Setup</h1>
     <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600">Simple instructions for connecting Expense Manager Pro, opening your records on another device and understanding how backups work.</p>
    </div>
   </div>
   <div className="mt-5 flex flex-wrap gap-2">
    {googleEnabled?<Link to="/settings" state={{openTab:'google'}} className="inline-flex min-h-11 items-center gap-2 rounded-xl bg-[#0176D3] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#0065b6]"><Fi.FiCloud/> Open Google setup <Fi.FiArrowRight/></Link>:
    <Link to="/settings" className="inline-flex min-h-11 items-center gap-2 rounded-xl bg-[#0176D3] px-4 py-2.5 text-sm font-bold text-white">Open Settings <Fi.FiArrowRight/></Link>}
    <Link to="/transactions" className="inline-flex min-h-11 items-center gap-2 rounded-xl border border-blue-200 bg-white px-4 py-2.5 text-sm font-bold text-[#0176D3] hover:bg-blue-50">Go to transactions</Link>
   </div>
  </header>

  <nav aria-label="Help topics" className="flex flex-wrap gap-2 text-sm">
   <a href="#first-time" className="rounded-full border border-slate-200 bg-white px-3 py-2 font-semibold text-[#385575] hover:border-blue-300">First-time setup</a>
   <a href="#other-device" className="rounded-full border border-slate-200 bg-white px-3 py-2 font-semibold text-[#385575] hover:border-blue-300">Another device</a>
   <a href="#sync-explained" className="rounded-full border border-slate-200 bg-white px-3 py-2 font-semibold text-[#385575] hover:border-blue-300">How syncing works</a>
   <a href="#help-troubleshooting" className="rounded-full border border-slate-200 bg-white px-3 py-2 font-semibold text-[#385575] hover:border-blue-300">Troubleshooting</a>
  </nav>

  <section id="first-time" className="min-w-0 space-y-4 rounded-2xl border border-[#dce5f0] bg-white p-4 shadow-sm sm:p-6" aria-labelledby="first-time-heading">
   <div className="flex items-start gap-3"><span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-sky-50 text-[#0176D3]"><Fi.FiUserCheck size={22}/></span>
    <div><h2 id="first-time-heading" className="text-lg font-extrabold text-[#032D60]">1. Set up for the first time</h2><p className="mt-1 text-sm text-slate-600">Use these steps when your BPA customer workspace has not been connected yet.</p></div>
   </div>
   <ol className="grid min-w-0 gap-2">
    <GuideStep number="1" title="Sign in to Expense Manager">Log in with the BPA customer email and password provided for your application.</GuideStep>
    <GuideStep number="2" title="Open Google setup">Go to <strong>Settings → Google Sheets Sync</strong> and select <strong>Authorise Google</strong>. Pick the Google account that will own your financial workbook.</GuideStep>
    <GuideStep number="3" title="Continue the Google approval">In Google's sign-in/permissions window, review the requested access and select <strong>Continue</strong> or <strong>Allow</strong> as prompted. Return to Expense Manager once authorisation completes. The wording may vary by Google account.</GuideStep>
    <GuideStep number="4" title="Create your workbook once">Choose <strong>Create a new BPA Sheet</strong>, then <strong>Confirm and create my Google Sheet</strong>. If an existing workbook is already linked, reuse it instead of creating a second one.</GuideStep>
    <GuideStep number="5" title="Wait for the verified backup">Keep the page open while the app creates, links and verifies the initial backup. Confirm that setup reports success and the top-bar Google backup status is ready before you start working.</GuideStep>
   </ol>
  </section>

  <section id="other-device" className="min-w-0 space-y-4 rounded-2xl border border-[#dce5f0] bg-white p-4 shadow-sm sm:p-6" aria-labelledby="other-device-heading">
   <div className="flex items-start gap-3"><span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-emerald-50 text-emerald-700"><Fi.FiSmartphone size={22}/></span>
    <div><h2 id="other-device-heading" className="text-lg font-extrabold text-[#032D60]">2. Open your workspace on another device</h2><p className="mt-1 text-sm text-slate-600">For a different browser, phone or computer using the <strong>same BPA customer login</strong>.</p></div>
   </div>
   <ol className="grid min-w-0 gap-2">
    <GuideStep number="1" title="Sign in with the same BPA account">Log in using the same BPA customer credentials as your original device. A completely different BPA customer account cannot automatically access your financial workspace.</GuideStep>
    <GuideStep number="2" title="Authorise Google on this device">Open <strong>Settings → Google Sheets Sync</strong>, choose <strong>Authorise Google</strong> and approve access using a Google account that can access your existing workbook.</GuideStep>
    <GuideStep number="3" title="Use the detected workbook">The app retrieves the registered <strong>Google Sheet ID</strong> for this BPA customer and should display <strong>We found a linked workbook</strong>. If prompted, select <strong>Connect and verify this workbook</strong>. Do not create another workbook.</GuideStep>
    <GuideStep number="4" title="Check for existing records">Select <strong>Check Sheet</strong> to compare the verified Google revision with this device. Detecting the Sheet ID does <strong>not</strong> automatically download its transactions.</GuideStep>
    <GuideStep number="5" title="Restore when you need the latest data">If this device has no records, or its records need to be replaced with the saved version, select <strong>Restore from Sheet</strong>, review the warning and type <strong>RESTORE</strong>. The app requests a safety download of this device's data first. Follow the staged messages and select <strong>Open restored workspace</strong> when complete.</GuideStep>
   </ol>
   <aside className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm leading-6 text-amber-950">
    <p className="flex items-start gap-2 font-bold"><Fi.FiAlertTriangle className="mt-1 shrink-0"/>Important before restoring</p>
    <p className="mt-1">Restore <strong>replaces</strong> the records currently stored on this device. If you have unsynced changes here, make sure they are backed up before restoring another device's data. Never assume a detected Sheet ID means the financial records are already current.</p>
   </aside>
  </section>

  <section id="sync-explained" className="min-w-0 space-y-4 rounded-2xl border border-[#dce5f0] bg-white p-4 shadow-sm sm:p-6" aria-labelledby="sync-explained-heading">
   <div className="flex items-start gap-3"><span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-blue-50 text-[#0176D3]"><Fi.FiRefreshCw size={22}/></span>
    <div><h2 id="sync-explained-heading" className="text-lg font-extrabold text-[#032D60]">3. Does it sync automatically between devices?</h2><p className="mt-1 text-sm text-slate-600">Not fully. Automatic backup and automatic cross-device download are different things.</p></div>
   </div>
   <div className="grid min-w-0 gap-3 md:grid-cols-2">
    <div className="min-w-0 rounded-xl border border-emerald-200 bg-emerald-50 p-4"><p className="flex items-center gap-2 text-sm font-bold text-emerald-900"><Fi.FiCheckCircle/> Automatic upload</p><p className="mt-2 text-sm leading-6 text-emerald-950">Edits made on this device are backed up while the app is open, Google authorisation is active, and the saved workbook revision is verified. The top-bar status shows success or warns when a backup is paused.</p></div>
    <div className="min-w-0 rounded-xl border border-amber-200 bg-amber-50 p-4"><p className="flex items-center gap-2 text-sm font-bold text-amber-950"><Fi.FiAlertCircle/> Manual download / restore</p><p className="mt-2 text-sm leading-6 text-amber-950">Changes made on another device do not automatically appear here. Use <strong>Check Sheet</strong> and, if needed, <strong>Restore from Sheet</strong> to load the latest verified records.</p></div>
   </div>
   <div className="space-y-2 text-sm leading-6 text-slate-700">
    <p><strong>Do I need to restore every time I sign in?</strong> No. Your verified local records stay on that device. Restore only when you need to load a newer saved revision from elsewhere or recover missing local data.</p>
    <p><strong>Can I edit on two devices at the same time?</strong> Not reliably. Use one device at a time until both copies have been reconciled. If Google permissions expire, reconnect Google to resume backups; local data remains available.</p>
   </div>
  </section>

  <section id="help-troubleshooting" className="min-w-0 space-y-3 rounded-2xl border border-[#dce5f0] bg-white p-4 shadow-sm sm:p-6" aria-labelledby="help-troubleshooting-heading">
   <h2 id="help-troubleshooting-heading" className="text-lg font-extrabold text-[#032D60]">Common questions</h2>
   <div className="divide-y divide-slate-100">
    <details className="group py-3"><summary className="cursor-pointer text-sm font-bold text-[#032D60]">I can sign in, but Google asks me to approve again.</summary><p className="mt-2 text-sm leading-6 text-slate-600">Google permission is specific to your browser session and may expire. Reopen Google setup and use <strong>Authorise Google</strong> or <strong>Reconnect Google</strong>. Your stored financial data is not deleted when permission expires.</p></details>
    <details className="group py-3"><summary className="cursor-pointer text-sm font-bold text-[#032D60]">My workbook was found, but my transactions are missing.</summary><p className="mt-2 text-sm leading-6 text-slate-600">A linked Sheet ID is not a completed restore. Authorise Google, use <strong>Check Sheet</strong>, confirm the remote revision and then <strong>Restore from Sheet</strong> if this device should use that saved copy.</p></details>
    <details className="group py-3"><summary className="cursor-pointer text-sm font-bold text-[#032D60]">The cloud status says paused, conflict or needs attention.</summary><p className="mt-2 text-sm leading-6 text-slate-600">Do not create another workbook or repeatedly click upload. Open Google setup, reconnect permission if required and review the detailed status. A revision conflict needs reconciliation before it is safe to upload more changes.</p></details>
    <details className="group py-3"><summary className="cursor-pointer text-sm font-bold text-[#032D60]">I signed in with a different BPA customer account.</summary><p className="mt-2 text-sm leading-6 text-slate-600">Customer workspaces are isolated. To access an existing customer workspace, use its authorised BPA login. Contact your BPA administrator if you need another user to receive access; Google authorisation alone does not grant BPA application access.</p></details>
   </div>
   {googleEnabled&&<Link to="/settings" state={{openTab:'google'}} className="inline-flex min-h-11 items-center gap-2 rounded-xl border border-[#0176D3] px-4 py-2.5 text-sm font-bold text-[#0176D3] hover:bg-blue-50"><Fi.FiCloud/> Open Google setup <Fi.FiArrowRight/></Link>}
  </section>
  <p className="px-1 text-xs leading-5 text-slate-500">BPA Solutions · Expense Manager Pro 2.0. This guide describes the current app behaviour; always confirm the latest verified backup before replacing local records.</p>
 </div>;
}

export default Settings;